#import "~/graphql/fragments/pageContent/defaultPageContent.graphql"
#import "~/graphql/fragments/pageContent/subsidyPageContent.graphql"

query getSubsidyPage(
    $site: [String!]
    $uri: [String!]
    $slug: [String!]
    $section: [String]
    $type: [String!]
    $now: [QueryArgument]
    $id: [QueryArgument]
) {
    entry(
        uri: $uri
        slug: $slug
        site: $site
        section: $section
        type: $type
        id: $id
    ) {
        __typename
        uri
        ... defaultPageContent
        ... subsidyPageContent
        ... on subsidy_Entry {
            periodsRelation(
                plainDate2: $now,
                orderBy: "plainDate2 ASC",
                limit: 1
            ) {
                id
                title
                ... on default_Entry {
                    start: plainDate @formatDateTime(format: "c", timezone: "Europe/Amsterdam")
                    end: plainDate2 @formatDateTime(format: "c", timezone: "Europe/Amsterdam")
                }
            }
        }
    }
}
